import React from "react";
import Scharnier from "../../doors/scharnier";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SingleScharnierProps extends ConfigurationProps {}
const SingleScharnier: React.FC<SingleScharnierProps> = ({
  materials,
  position,
  scale,
  doorSettings,
}: SingleScharnierProps) => {
  const { sceneStaanderPosition } = useConfigurationOptionsContext();

  return (
    <group scale={scale}>
      <Scharnier
        materials={materials}
        position={position}
        frameSettings={doorSettings?.main?.frameSettings}
        lockSettings={doorSettings?.main?.lockSettings}
        verticalBeamPosition={sceneStaanderPosition}
      />
    </group>
  );
};

export default SingleScharnier;
